import api from './api/api';

export const save = async (license) => api.post('/licenses/request', license).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const getLicensesByEnterprise = (enterpriseId) => api.get(`/licenses/enterprises/${enterpriseId}`).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const getAllLicenses = (filters) => api.get(`/licenses?allocatedRegulator=${filters.allocatedRegulator}&page=${filters.page - 1}${filters.tag ? `&tag=${filters.tag}` : ''}${filters.stepStatus ? `&stepStatus=${filters.stepStatus}` : ''}`).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const uploadDocument = async (document, file) => api.postForm(`/licenses/documents/${document.id}`, { file }).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const downloadDocument = async (document) => api.get(`/licenses/documents/${document.id}`, { responseType: 'blob' }).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const sendMessageToDocument = async (document, message) => api.post(`/licenses/documents/${document.id}/messages`, { message }).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const getDocumentMessages = (document) => api.get(`/licenses/documents/${document.id}/messages`).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const getDocumenPayment = (document) => api.get(`/licenses/documents/${document.id}/payment`, { responseType: 'blob' }).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const addCategory = (license, category) => api.post(`/licenses/${license.id}/tags/${category}`).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const removeCategory = (license, category) => api.delete(`/licenses/${license.id}/tags/${category}`).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const getLicenseMessages = (license) => api.get(`/licenses/${license.id}/internal-messages`).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const sendMessageToLicense = async (license, message) => api.post(`/licenses/${license.id}/internal-messages`, { message }).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const allocateRegulator = async (license) => api.post(`/licenses/${license.id}/allocate-regulator`).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const deferLicense = async (license, step) => api.post(`/licenses/${license.id}/steps/${step}/defer`).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const rejectLicense = async (license, step) => api.post(`/licenses/${license.id}/steps/${step}/reject`).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});
